<template>
  <div>
    <!-- 列表视图：当审核弹框或详情弹框显示时隐藏 -->
    <div v-if="!dialog.show && !dialogDetails.show">
      <div class="top">
        <el-input
            v-model="search.cpmc"
            placeholder="产品名称"
            style="width: 250px; margin-right: 10px"
            size="small"
            clearable
            @clear="clear('cpmc')"
        />

        <el-select v-model="search.status" clearable @clear="clear('status')" placeholder="订单状态" size="small" style="width: 200px;">
          <el-option
            v-for="item in statusOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            @click.native="changeStatus(item)"
            >
          </el-option>
        </el-select>

        <el-button
          icon="el-icon-search"
          size="small"
          style="margin-left: 10px"
          @click="queryData()"
          >查询</el-button>

        <el-button
          type="danger"
          icon="el-icon-refresh-left"
          size="small"
          @click="reseData()"
          >重置</el-button>

      </div>

      <el-table
        ref="multipleTable"
        :data="tableData"
        :highlight-current-row="true"
        stripe
        row-key="id"
        style="width: 100%; margin-top: 20px;border-radius:16px;"
        :loading="loading"
      >
        <el-table-column type="index" label="序号" width="55" />
        <el-table-column prop="orderNo" width="210" label="订单编号" />
        <el-table-column prop="cpmc" width="160" label="产品名称" />
        <!-- <el-table-column prop="dkedxx" label="申请额度">
        <template slot-scope="scope">
            <span>{{ scope.row.dkedxx +' ~ '+ scope.row.dkedsx + '万元'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dkqxxx" label="贷款期限">
          <template slot-scope="scope">
            <span>{{ scope.row.dkqxxx +' ~ '+ scope.row.dkqxsx + '月'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="zdnhlv" label="年化利率">
          <template slot-scope="scope">
            <span>{{ scope.row.zdnhlv+'%' +' ~ '+ scope.row.zgnhlv + '%'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="企业联系人" />
                <el-table-column prop="phone" label="企业联系人电话" />
        <el-table-column prop="khjl" label="客户经理"  />
        <el-table-column prop="lxrdh" label="联系电话"  /> -->

        <el-table-column prop="qymc" label="申请企业" />
        <el-table-column prop="username" label="企业联系人及电话">
          <template slot-scope="scope">
            <span>{{ scope.row.username +'  '+ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="khjl" label="客户经理及电话">
          <template slot-scope="scope">
            <span>{{ scope.row.khjl +'  '+ scope.row.lxrdh }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="150" >
          <template slot-scope="scope">
            <el-button size="small" type="info" plain v-if="scope.row.status==0">取消订单</el-button>
            <el-button size="small" type="primary" plain v-else-if="scope.row.status==1">待审核</el-button>
            <el-button size="small" type="danger" plain v-else-if="scope.row.status==2">审核不通过</el-button>
            <el-button size="small" type="warning" plain v-else-if="scope.row.status==3">授信中</el-button>
            <el-button size="small" type="primary" plain v-else-if="scope.row.status==4">授信待确认</el-button>
            <el-button size="small" type="danger" plain v-else-if="scope.row.status==5">金融机构授信不通过</el-button>
            <el-button size="small" type="success" plain v-else-if="scope.row.status==6">同意授信</el-button>
            <el-button size="small" type="danger" plain v-else-if="scope.row.status==7">企业不同意授信</el-button>
            <el-button size="small" type="info" plain v-else-if="scope.row.status==8">撮合成功（已完成）</el-button>
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="(scope.row.status==1)" @click="handleReview(scope.row,'审核',1)">审核</el-button>
            <el-button type="text" size="small" v-if="(scope.row.status==3)" @click="handleReview(scope.row,'授信',2)">授信</el-button>
            <el-button type="text" size="small" v-if="(scope.row.status==6)" @click="handleReview(scope.row,'上传合同',3)">上传合同</el-button>
            <el-button type="text" size="small" v-if="(scope.row.status==8)" @click="handleReview(scope.row,'查看合同',4)" >查看合同</el-button>
            <el-button type="text" size="small" @click="handleDetails(scope.row,'详情')">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, sizes,prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page.sync="page.current"
          :page-size.sync="page.size"
          :total="page.total"
          @current-change="queryData"
          @size-change="handleQuery"
        />
      </div>

    </div>

   <!-- 订单审核 -->
   <order-review
      v-if="dialog.show"
      :show="dialog.show"
      :title="dialog.title"
      :type="dialog.type"
      :view-data="dialog.viewData"
      @closeDialog="closeDialog"
    />

    <!-- 订单详情（内联模式 type=0） -->
    <order-details
      v-if="dialogDetails.show"
      :show="dialogDetails.show"
      :title="dialogDetails.title"
      :type="dialogDetails.type"
      :view-data="dialogDetails.viewData"
      @closeDialog="closeDialogDetails"
    />

  </div>
</template>

<script>
import orderReview from './components/orderReview.vue'
import orderDetails from './components/orderDetails.vue'
import {getProductOrder} from "@/views/financInstitutionPC/viewApi";

export default {
  components: {
    orderReview,
    orderDetails
  },
  data() {
    return {
      search:{
        name:'',
        cpmc:'',
        status:'',
      },
      options:[],
      loading: false,
      page: {
        size: 10,
        total: 0,
        current: 1
      },
      dialog: {
        show: false,
        type: '',
        viewData: {},
        title: "",
      },
      dialogDetails: {
        show: false,
        hideUnit: false,
        viewData: {},
        title: "",
      },
      tableData:[ ],
      statusOption:[
        {
        value: '0',
        label: '取消订单'
        },
        {
        value: '1',
        label: '待审核'
        },
        {
          value: '2',
          label: '审核不通过'
        },
        {
          value: '3',
          label: '授信中'
        },
        {
          value: '4',
          label: '授信待确认'
        },
        {
          value: '5',
          label: '金融机构授信不通过'
        },
        {
          value: '6',
          label: '同意授信'
        },
        {
          value: '7',
          label: '企业不同意授信'
        },
        {
          value: '8',
          label: '撮合成功（已完成）'
        },
      ],
    }
  },
  mounted() {
    this.queryData();
    // 从消息跳转过来时，直接打开对应订单详情
    this.$nextTick(() => {
      if (this.$route.query.highlightId) {
        this.openDetailById(this.$route.query.highlightId);
      }
    });
    // 监听从铃铛直接打开详情的事件
    window.addEventListener('openOrderDetail', this.handleOpenOrderDetail);
  },
  beforeDestroy() {
    window.removeEventListener('openOrderDetail', this.handleOpenOrderDetail);
  },
  methods: {
    handleOpenOrderDetail(event) {
      const id = event.detail.id;
      this.openDetailById(id);
    },
    openDetailById(id) {
      const targetId = Number(id);
      const index = this.tableData.findIndex(item => item.id === targetId);
      if (index !== -1) {
        this.handleDetails(this.tableData[index], '详情');
      } else {
        this.findAndOpenDetail(targetId);
      }
    },
    findAndOpenDetail(targetId) {
      let currentPage = 1;
      const pageSize = this.page.size;
      const search = () => {
        let param = {
          cpmc: this.search.cpmc,
          status: this.search.status,
          current: currentPage,
          size: pageSize,
        };
        getProductOrder(param).then(res => {
          if (res.code == 1000) {
            this.tableData = res.data.records.map((item) => ({ ...item }));
            this.page.total = res.data.total;
            this.page.current = currentPage;
            const index = this.tableData.findIndex(item => item.id === targetId);
            if (index !== -1) {
              this.$nextTick(() => {
                this.handleDetails(this.tableData[index], '详情');
              });
            } else if (currentPage * pageSize < res.data.total) {
              currentPage++;
              search();
            } else {
              this.$message.warning('未找到对应记录');
            }
          }
        });
      };
      search();
    },

    handleQuery () {
      this.page.current = 1
      this.queryData()
    },
    queryData(){
      let param ={
        cpmc: this.search.cpmc,
        status: this.search.status,
        ...this.page,
      }
      getProductOrder(param).then(res => {
        if (res.code == 1000) {
          this.tableData = res.data.records.map((item)=>{
              return {
                ...item
              }
          })
          this.page.total = res.data.total
        }
      })
    },

    changeItem( data ){
      this.search.cpmc = data.cpmc;
    },

    changeStatus( data ){
      this.search.status = data.value;
      this.queryData();
    },

    clear(key){
      key&&(this.search[key] = '')
      this.queryData();
    },


    //订单审核
    handleReview(row , title ,type){
      //审核1  授信2  上传合同3  查看合同4
      this.dialog.type =type;
      this.dialog.title = title;
      this.dialog.viewData = {...row};
      this.dialog.show = true;
    },
    closeDialog(needRefresh) {
      this.dialog.show = false;
      this.dialog.viewData = {};
      this.dialog.title = "";
      needRefresh && this.queryData();
    },


    //详情
    handleDetails(row , title){
      this.dialogDetails.type = 0;
      this.dialogDetails.title = title;
      this.dialogDetails.viewData = {...row};
      this.dialogDetails.show = true;
    },
    // 关闭详情弹窗
    closeDialogDetails(needRefresh) {
      this.dialogDetails.show = false;
      this.dialogDetails.viewData = {};
      this.dialogDetails.title = "";
      needRefresh && this.queryData();
    },

    reseData(){
      this.search={
        name:'',
        cpmc:'',
        status:'',
      };
    },

  }
};
</script>
